import { TypeDATA_ALL_PAGE } from "../slices/authSlice/authSlice";
import { api } from "./apiCore";

export const permissionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPermission: builder.query<TypeDATA_ALL_PAGE, void>({
      query: () => ({
        url: `auth/system-bank/bank/kamkombank/permission`,
      }),
    }),
  }),
});

export const { useGetPermissionQuery } = permissionApi;
